import { Controller } from "@hotwired/stimulus"
import React from "react";
import { createRoot } from "react-dom/client";
import Tracking from "../components/Tracking.jsx";


export default class extends Controller {
  static values = {
    eventId: Number
  };
  connect() {
    document.addEventListener("turbo:load", () => {
      if (!this.root) {
        this.root = createRoot(this.element);
      }
      this.root.render(<Tracking/>);
      const props = {
        eventId: this.hasEventIdValue ? this.eventIdValue : null,
      };
      this.root.render(<Tracking {...props} />);
    });
  }
}